module.exports = __webpack_public_path__ + "img/13.f558fe86.png";